import { gsap } from "gsap";
// import BezierEasing from 'bezier-easing';

import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import NoScroll from './NoScroll';
import InfiniteScroll from '../_app/cuchillo/scroll/InfiniteScroll';
import InfiniteScroll__Item from '../_app/cuchillo/scroll/InfiniteScroll__Item';
import { GetBy } from '../_app/cuchillo/core/Element';
import { CSS } from "../_app/cuchillo/utils/CSS";
import { Basics, isMobile } from "../_app/cuchillo/core/Basics";
import { Maths } from "../_app/cuchillo/utils/Maths";
import { Metrics } from "../_app/cuchillo/core/Metrics";

export default class Metodologia extends NoScroll {
  sliderDom;
  scroller;
  names;

  static sound = new Howl({
      src: ['/assets/audio/tac.mp3'],
      volume: 1,
      preload: true,
      html5: false,
      onload: () => {
        console.log("🎧 Sonido precargado");
      },
      onloaderror: (id, err) => {
        console.error("❌ Error al cargar el sonido", err);
      },
      onend: () => {}
    });

  constructor() {
    super();

    this.sliderDom = GetBy.class('__slider', this.container)[0];
    this.scroller = new InfiniteScroll(InfiniteScroll.AXIS_Y, {
      domResize: this.sliderDom,
      container: this.sliderDom,
      multiplicator: 3,
      itemClass: Project__Item,
      inverted: false,
      gap: 0,
      hasVirtuaScroll: true
    });

    this.viewer = new Viewer(GetBy.selector('.__viewer .viewer', this.container)[0]);
  }

  afterShow() {
    super.afterShow();

    this.scroller.show();
    this.scroller.start();

    this.viewer.show();
  }

  beforeHide() {
    super.beforeHide();
    this.scroller.stop();

    this.viewer.hide();
  }

  loop() {
    super.loop();

    this.scroller.loop();
    this.viewer.loop(this.scroller.actual);
  }

  dispose() {
    this.scroller.dispose();
    this.viewer.dispose();

    super.dispose();
  }

  resize(__w, __h) {
    super.resize(__w, __h);
    this.scroller.resize();
    this.viewer.resize();
  }
}

ControllerPage._addPage('metodologia', Metodologia);

class Project__Item extends InfiniteScroll__Item {
  name;
  nameHeight = 0;
  nameHeightActive = 0;
  anchor;
  cb;
  scroller;
  realIndex = 0;

  constructor(__d, __i, __axis = InfiniteScroll.AXIS_Y, __scroller) {
    super(__d, __i, __axis, true);

    this.name = GetBy.selector(".__progress .__index")[this.index];
    this.realIndex = parseInt(this.name.dataset.index);

    this.anchor = GetBy.selector(".__name", this.name)[0];
    gsap.set(this.anchor, { opacity: 0 });

    this.siblings = __scroller._items;
    this.cb = __scroller._cb;
    this.scroller = __scroller;
  }

  show() {
    super.show();

    let i = 0;
    if (this.index >= .4 || this.index <= 4) i = this.index + 4;

    gsap.set(this.anchor, { opacity: 1, delay: .1 * i });
  }

  hide() {
    super.hide();
    gsap.set(this.anchor, { opacity: 0 });
  }

  drawHook() {
    const p = this.progressInside - 1;

    let y = Maths.lerp(this.nameHeight, 0, p);
    this.name.style[CSS.transform] = CSS.translate3D(0, y, 0);

    if (p < -2.5 || p >= 2.5) {
      this.name.classList.add('--hidden');
    } else {
      this.name.classList.remove('--hidden');
    }

    this.name.classList.remove('--displace-up');
    this.name.classList.remove('--displace-down');
    this.name.classList.remove('--active');

    if (p > -.5 && p <= .5) this.name.classList.add('--active');
    else if (p > 0) this.name.classList.add('--displace-up');
    else if (p < 0) this.name.classList.add('--displace-down');
  }

  resize() {
    super.resize();

    if (this.name) {
      this.name.classList.add('--active');
      this.nameHeightActive = this.name.getBoundingClientRect().height;
      this.name.style.setProperty('--height-active', this.nameHeightActive + 'px');
      this.name.classList.remove('--active');

      this.nameHeight = Math.max(46, this.name.getBoundingClientRect().height);
      this.name.style.setProperty('--height', this.nameHeight + 'px');
    }
  }
}

class Viewer {
  dom;
  items = [];

  current = -1;
  speed = 1;
  tick = 0;
  _firstSound = true;

  constructor(__d) {
    this.dom = __d;

    this.items = GetBy.class('__item', this.dom);

    gsap.set(this.dom, { opacity: 0 });
    gsap.set(this.items, { opacity: 0 });

    this.resize();
    this.loop(0);
  }

  show() {
    gsap.set(this.dom, { opacity: 1, delay: .8 });
    gsap.set(this.items[0], { opacity: 1 });
  }

  hide() {
    gsap.set(this.items[this.current], { opacity: 0 });
  }

  loop(c) {
    if (this.current !== c) {
      if(!this._firstSound) {
        Metodologia.sound.play();
      }
      this._firstSound = false;

      const oldImg = this.items[this.current];

      if (oldImg) {
        gsap.killTweensOf(oldImg);
        gsap.set(oldImg, { opacity: 0 });

        const video = GetBy.selector('video', oldImg)[0];
        if (video) video.pause();
      }

      const newImg = this.items[c];

      const video = GetBy.selector('video', newImg)[0];
      if (video) video.play();

      gsap.killTweensOf(newImg);
      gsap.set(newImg, { opacity: 1 });

      this.current = c;
    }
  }

  resize() {
    const innerH = window.innerHeight;
    const innerW = window.innerWidth;

    for (let i = 0; i < this.items.length; i++) {
      const element = this.items[i];

      if (!element.classList.contains('--big')) {
        const card = GetBy.class('__card', element)[0];
        const rect = card.getBoundingClientRect();
        const cardW = rect.width;
        const cardH = rect.height;

        const randomInRanges = (ranges) => {
          const range = ranges[Math.floor(Math.random() * ranges.length)];
          const [min, max] = range;
          return Math.random() * (max - min) + min;
        };

        let rangesX = [
          [innerW * 0.05, innerW * 0.3],
          [innerW * 0.5, innerW * .95 - cardW],
        ];

        let rangesY = [
          [innerH * 0.1, innerH * 0.2],
          [innerH * 0.5, innerH * .9 - cardH],
        ]

        if (isMobile) {
          rangesX = [
            [innerW * 0.1, innerW * .9 - cardW]
          ]

          rangesY = [
            [innerH * .98 - cardH, innerH * .98 - cardH],
          ]
        }

        const x = randomInRanges(rangesX);
        const y = randomInRanges(rangesY);

        card.style.position = 'absolute';
        card.style.left = `${x}px`;
        card.style.top = `${y}px`;
      }
    }
  }
}
